/**
 * Cursor-following spotlight for glass CTAs (desktop only).
 */
(function () {
  var DESKTOP_QUERY = '(min-width: 1025px)';
  var GLASS_BUTTON_SELECTOR = '.ds-btn--glass-white, .ds-btn--glass-dark';

  function bindGlassButton(button) {
    if (button.dataset.glassInit === 'true') return;
    button.dataset.glassInit = 'true';

    button.addEventListener('mouseenter', onEnter);
    button.addEventListener('mousemove', onMove);
    button.addEventListener('mouseleave', onLeave);
  }

  function getEffect(button) {
    var effect = button.querySelector('.ds-btn__hover-effect');
    if (!effect) {
      effect = document.createElement('span');
      effect.className = 'ds-btn__hover-effect';
      effect.setAttribute('aria-hidden', 'true');
      button.insertBefore(effect, button.firstChild);
    }
    return effect;
  }

  function sizeEffect(button, effect) {
    var size = button.offsetHeight * 3.5;
    effect.style.width = size + 'px';
    effect.style.height = size + 'px';
  }

  function positionEffect(button, effect, clientX, clientY) {
    var rect = button.getBoundingClientRect();
    effect.style.left = clientX - rect.left + 'px';
    effect.style.top = clientY - rect.top + 'px';
  }

  function onEnter(event) {
    if (!window.matchMedia(DESKTOP_QUERY).matches) return;

    var button = event.currentTarget;
    var effect = getEffect(button);
    sizeEffect(button, effect);
    positionEffect(button, effect, event.clientX, event.clientY);

    window.requestAnimationFrame(function () {
      effect.classList.add('is-active');
    });
  }

  function onMove(event) {
    if (!window.matchMedia(DESKTOP_QUERY).matches) return;

    var button = event.currentTarget;
    var effect = button.querySelector('.ds-btn__hover-effect');
    if (!effect) return;

    positionEffect(button, effect, event.clientX, event.clientY);
  }

  function onLeave(event) {
    var effect = event.currentTarget.querySelector('.ds-btn__hover-effect');
    if (effect) effect.classList.remove('is-active');
  }

  function initGlassButtons(root) {
    var scope = root || document;
    scope.querySelectorAll(GLASS_BUTTON_SELECTOR).forEach(bindGlassButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGlassButtons();
    });
  } else {
    initGlassButtons();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initGlassButtons(event.target);
  });

  document.addEventListener('ds:init-glass-buttons', function (event) {
    initGlassButtons(event.detail && event.detail.root ? event.detail.root : document);
  });
})();
